import React from 'react';
import { Box, Grid, Typography, Link } from '@mui/material';
import FooterIconButton from './FooterIconButton.tsx';

import {
  faFacebook, faInstagram, faYoutube, faLinkedin
} from "@fortawesome/free-brands-svg-icons";
import { faMapMarkerAlt, faPhone, faEnvelope, faFileAlt } from "@fortawesome/free-solid-svg-icons";
import { library } from "@fortawesome/fontawesome-svg-core";

library.add(faFacebook, faInstagram, faYoutube, faLinkedin, faMapMarkerAlt, faPhone, faEnvelope, faFileAlt);

export default function Footer() {
  return (
    <Box sx={{
      backgroundImage: 'url(https://res.cloudinary.com/dhoyyqszi/image/upload/v1739228337/ebm/footer-background_w0wsor.png)',
      backgroundRepeat: "no-repeat",
      backgroundSize: { xs: 'cover', lg: "100%" },
      backgroundPosition: { xs: "top center", lg: "top left" },
      backgroundColor: 'black',
      color: 'white',
      paddingTop: '2em',
      paddingBottom: { lg: '1em' },
      position: 'relative'
    }}>
      <Grid container justifyContent={{ xs: 'center', md: 'flex-start' }} spacing={2}>
        {/* Sección Izquierda */}
        <Grid item xs={12} md={7} lg={4} xl={3}
          sx={{
            mr: 'auto',
            ml: { lg: '20px' },
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'left',
            paddingRight: { xs: '0px', md: '2rem', lg: '4rem' },
            py: 4,
            mt: { xs: 4, md: 6 } 
          }}>

          <Box sx={{ width: '100%', maxWidth: '165px', mx: 'auto' }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
              <img
                src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1739207068/ebm/EBM_logo_blanco_etu8yj.png"
                alt="Logo"
                style={{ width: '100%', height: 'auto' }}
              />
              <Box sx={{
                display: 'flex',
                gap: 1,
                mt: { xs: 2, md: '15px' }
              }}>
                <FooterIconButton
                  size="sm"
                  href="https://www.facebook.com/ebmconsultingmx"
                  icon={<img src='https://res.cloudinary.com/dhoyyqszi/image/upload/v1744331881/ebm/icon-face_rbi2fa.png' alt='Facebook' style={{ maxWidth: '13px', maxHeight: '13px' }} />}
                />
                <FooterIconButton
                  size="sm"
                  href="https://www.instagram.com/ebmconsultingmx/"
                  icon={<img src='https://res.cloudinary.com/dhoyyqszi/image/upload/v1744331881/ebm/icon-insta_k8mhz4.png' alt='Instagram' style={{ maxWidth: '13px', maxHeight: '13px' }} />}
                />
                <FooterIconButton
                  size="sm"
                  href="https://www.tiktok.com/@ebmconsultingmx"
                  icon={<img src='https://res.cloudinary.com/dhoyyqszi/image/upload/v1750185412/ebm/tik-tok_hjmv8v.png' alt='Tiktok' style={{ maxWidth: '13px', maxHeight: '13px', filter: 'brightness(0) invert(1)' }} />}
                />
                <FooterIconButton
                  size="sm"
                  href="https://www.linkedin.com/company/ebmconsultingmx/"
                  icon={<img src='https://res.cloudinary.com/dhoyyqszi/image/upload/v1744331881/ebm/icon-in_ymhvst.png' alt='Linkedin' style={{ maxWidth: '13px', maxHeight: '13px' }} />}
                />
              </Box>
              <Typography sx={{ fontSize: '12px', mt: 2, whiteSpace: 'nowrap' }}>
                © Todos los derechos reservados
              </Typography>
            </Box>
          </Box>
        </Grid>

        {/* Sección Derecha */}
        <Grid item xs={12} md={5} lg={4} sx={{
          borderLeft: { xs: 'none', md: '1px solid white' },
          textAlign: { xs: 'center', md: 'left' },
          paddingLeft: { md: '3rem' },
          paddingRight: { md: '20px' },
          mt: { xs: 2, md: 0 },
          display: 'flex',
          flexDirection: 'column',
          alignItems: { xs: 'center', md: 'flex-start' },
          justifyContent: 'space-evenly',
         
        }}>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Box component='img' src='https://res.cloudinary.com/dhoyyqszi/image/upload/v1744390919/ebm/icon-map_rkztfx.png' sx={{ mr: 2, maxWidth: '18px', maxHeight: '18px' }} />
            <Typography sx={{ fontSize: '12px' }}>
              Pacheco 19, Col San Benito, Hermosillo, Sonora, C.P. 83190
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <Box component='img' src='https://res.cloudinary.com/dhoyyqszi/image/upload/v1744390919/ebm/icon-cel_baofax.png' sx={{ mr: 2, maxWidth: '18px', maxHeight: '18px' }} />
            <Typography sx={{ fontSize: '12px' }}>
              <strong>Llámanos:</strong> <a href="tel:+526622155639" style={{ color: 'white', textDecoration: 'none' }}>(662)215-56-39</a> | <a href="tel:+526622155426" style={{ color: 'white', textDecoration: 'none' }}>(662)215-54-26</a>
            </Typography>
          </Box>
          <Link href="mailto:ebm@brconsultores.com.mx" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', textDecoration: 'none' }}>
            <Box component='img' src='https://res.cloudinary.com/dhoyyqszi/image/upload/v1744390919/ebm/icon-mail_imbo5x.png' sx={{ mr: 2, maxWidth: '18px', maxHeight: '18px' }} />
            <Typography sx={{ fontSize: '12px' }}>ebm@brconsultores.com.mx</Typography>
          </Link>
          <Link href="https://blog.ebmconsultores.com.mx/aviso-de-privacidad/" target="_blank" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', textDecoration: 'none' }}>
            <Box component='img' src='https://res.cloudinary.com/dhoyyqszi/image/upload/v1744390919/ebm/icon-doc_xj1mxb.png' sx={{ mr: 2, maxWidth: '18px', maxHeight: '18px' }} />
            <Typography sx={{ fontSize: '12px', textDecoration: 'underline' }}>Política de privacidad</Typography>
          </Link>
        </Grid>
      </Grid>

      {/* Logo BR Consultores */}
      <Box sx={{ display: 'flex', justifyContent: { xs: 'center', md: 'flex-end' }, mt: { xs: 3, md: 4 } }}>
        <a
          href="https://brconsultores.com.mx"
          target="_blank"
          rel="noopener noreferrer"
          style={{ position: 'absolute', bottom: '0', right: '0' }}
        >
          <Box
            component="img"
            src="https://res.cloudinary.com/dhoyyqszi/image/upload/v1749163339/ebm/LOGO_BR_blanco_1_itw00y.svg"
            alt="BR Consultores"
            sx={{
              position: 'absolute',
              bottom: 20,
              right: {
                xs: 8,
                md: 75,
                '@media (min-width:1600px)': 100
              },
              width: {
                xs: '70px',
                md: '70px',
                xl: '90px'
              },
              height: 'auto',
              zIndex: 2,
              cursor: 'pointer'
            }}
          />
        </a>
      </Box>
    </Box>
  );
}
